
import { Component, Vue } from "vue-property-decorator"
import ArticleMenu from "@/components/Header/ArticleMenu.vue"
import SpecialFeature from "@/components/Header/SpecialFeature.vue"
import AdminUserMenu from "@/components/Header/AdminUserMenu.vue"
import AppAffiliates from "@/components/Header/AppAffiliates.vue"
import ProfileMenu from "@/components/Header/ProfileMenu.vue"
import LogoutButton from "@/components/Header/LogoutButton.vue"
import Category from "@/components/Header/Category.vue"
import AdsAndSeoMenu from "@/components/Header/AdsAndSeoMenu.vue"
import { mapState } from "vuex"

@Component({
  components: {
    ArticleMenu,
    AdminUserMenu,
    ProfileMenu,
    LogoutButton,
    Category,
    AppAffiliates,
    AdsAndSeoMenu,
    SpecialFeature,
  },
  computed: mapState("adminUser", ["role"]),
})
export default class Header extends Vue {
  /* */
}
